var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefundCcLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5400_248178)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.67101 4.25718C9.59901 1.03818 15.404 1.26218 19.071 4.92918C22.976 8.83418 22.976 15.1662 19.071 19.0712C15.166 22.9762 8.83401 22.9762 4.92901 19.0712C3.73064 17.8744 2.85609 16.3928 2.38747 14.7653C1.91886 13.1378 1.87156 11.4179 2.25001 9.76718L2.32701 9.45418L4.26101 9.96418C3.78156 11.7864 3.96071 13.7195 4.76689 15.4226C5.57308 17.1257 6.95455 18.4896 8.66785 19.2739C10.3811 20.0582 12.3163 20.2125 14.1323 19.7098C15.9482 19.207 17.5285 18.0794 18.5944 16.5256C19.6604 14.9718 20.1438 13.0917 19.9593 11.2164C19.7747 9.34121 18.9342 7.5913 17.5859 6.27508C16.2375 4.95887 14.4678 4.16084 12.5887 4.02165C10.7096 3.88245 8.8416 4.41101 7.31401 5.51418L7.09301 5.68018L8.11001 6.69718L3.51401 7.75718L4.57401 3.16118L5.67101 4.25718Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 8.00018C9.00001 6.89561 9.89544 6.00018 11 6.00018H13C14.1042 6.00018 15 6.89498 15 7.99991V10.2145H13V8.00018H11V16.0002H13V13.8538H15V16.0007C15 17.106 14.1038 18.0002 13 18.0002H11C9.89545 18.0002 9.00001 17.1048 9.00001 16.0002V8.00018Z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5400_248178"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefundCcLine);
export default __webpack_public_path__ + "static/media/refund-CC-line.ca01a68075fa4be2e8a4c0e0270e032a.svg";
export { ForwardRef as ReactComponent };